import { render, staticRenderFns } from "./AxDropdownButton.vue?vue&type=template&id=44a7732d&scoped=true&"
import script from "./AxDropdownButton.vue?vue&type=script&lang=ts&"
export * from "./AxDropdownButton.vue?vue&type=script&lang=ts&"
import style0 from "./AxDropdownButton.vue?vue&type=style&index=0&id=44a7732d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a7732d",
  null
  
)

export default component.exports